  <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container">
  <div cdkDragHandle class="flex justify-between items-baseline pr-4">
    <h2 mat-dialog-title>Action Required: Future Login Credentials Update</h2>
    @if (!disableOktaMigrationPopupDismissal) {
      <button type="button" mat-icon-button class="leading-none" mat-dialog-close><mat-icon>close</mat-icon></button>
    }
  </div>

  <mat-divider></mat-divider>

  <mat-dialog-content>
    <p>
      Beginning in August 2026, all users will be required to use a unique email address as their username for platform access through InsureID by Okta.
    </p>

    <p>
      This transition supports enhanced security and compliance standards through multi-factor authentication (MFA), helping protect sensitive data and strengthen identity security.
    </p>
    <p> Key Information:</p>
    <ul class="list-disc px-6 mb-4">
      <li>Your selected email address must be for your individual use only and may not be shared with another account.</li>
      <li>Client and lead data will remain unchanged.</li>
      <li>Your overall platform experience will remain the same aside from the new authentication process.</li>
      <li>InsureID by Okta will provide secure, streamlined single sign-on access across supported platforms and carrier integrations.</li>
    </ul>

    <p class="font-semibold text-red-600">In late July or early August 2026 (exact date TBD), this notification can no longer be dismissed, and a selection will be required before accessing the platform. </p>

    <p class="font-semibold">Please select or enter the email address you would like to use for your future InsureID by Okta login credentials. Continue using your current login process until further notice.</p>

    @if (isLoading) {
      <div class="loading-indicator">
        <app-sms-spinner></app-sms-spinner>
      </div>
    }

    @if (!isLoading) {
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 items-start md:items-stretch">
        <div class="w-full min-w-0">
          <mat-radio-group [(ngModel)]="selectedEmail" class="w-full flex flex-col gap-2">
            @for (option of emailOptions; track option) {
              <mat-radio-button [value]="option.email" (change)="onRadioChange(option.email)">
                {{ option.email }}
              </mat-radio-button>
            }

            <div class="other-email-row">
              <mat-radio-button [value]="'__other__'" (change)="onRadioChange('__other__')">Other:</mat-radio-button>
              <mat-form-field class="other-email-field" subscriptSizing="dynamic">
                <input
                  matInput
                  [(ngModel)]="otherEmail"
                  (ngModelChange)="onEmailInputChange()"
                  [disabled]="!isOtherSelected"
                  [placeholder]="'example: johndoe@email.com'"
                  autocomplete="off"
                />
              </mat-form-field>
            </div>
          </mat-radio-group>
        </div>

        <div class="w-full min-w-0 md:pl-2 modal-error-col md:flex md:flex-col md:justify-end">
          @if (showInvalidEmailError) {
            <mat-error>
              <p>Invalid email address. Please use valid email address format.</p>
            </mat-error>
          }

          @if (showUnavailableEmailError) {
            <mat-error>
              <p>
                The email you selected is already in use by another user. Select or enter another email address. If you believe you are the rightful owner/user of the
                email address,
                <a class="linked-td" href="https://seniormarketsales.jotform.com/260064851091049" target="_blank" rel="noopener noreferrer">Click Here</a>
                to request assistance reclaiming the email as your username. This request will be treated as high priority. A representative will contact you about next steps ASAP.
              </p>
            </mat-error>
          }
        </div>
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    @if (!disableOktaMigrationPopupDismissal && !hasSelection) {
      <button type="button" mat-raised-button (click)="closeDialog()">Close</button>
    }

    @if (hasSelection) {
      @if (!disableOktaMigrationPopupDismissal) {
        <button type="button" mat-stroked-button (click)="closeDialog()">Cancel</button>
      }
      <button type="button" mat-raised-button color="primary" [disabled]="isSubmitting || submitDisabled" (click)="submit()">Submit</button>
    }
  </mat-dialog-actions>
</div>
